<template>
	<modal name="delete-song" :width="300" height="auto">
		<div id="delete-song-modal">
			<p>{{ $t('song.confirmDeleteSong') }}</p>
			<button type="button" class="confirm" @click="confirm">{{ $t('song.deleteSongButton') }}</button>
			<button type="button" class="cancel" @click="cancel">{{ $t('song.deleteCancelButton') }}</button>
		</div>
	</modal>
</template>

<script>
	import { SongService } from "@/services/SongService";
	import { mapState } from "vuex";

	export default {
		data() {
			return {
			};
		},
		computed: {
			...mapState([ "currentSong", "songsFilter" ])
		},
		methods: {
			confirm() {
				document.dispatchEvent(new Event("PrepareRouteToNextSong"));
				SongService.removeSong(this.currentSong);
				document.dispatchEvent(new Event("RouteToNextSong"));
				this.$modal.hide("delete-song");
			},
			cancel() {
				this.$modal.hide("delete-song");
			}
		}
	}
</script>

<style lang="scss" scoped>
	#delete-song-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		p {
			margin: 0;
			padding: 20px 20px 0 20px;
			font-size: 0.9em;
			font-weight: 300;
			line-height: 1.2em;
		}

		button {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			font-weight: 300;
			border: 0;
			margin: 20px 0 0 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}
		}

		button.confirm {
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			color: rgba(255, 255, 255, 0.8);
		}

		button.cancel {
			margin: 5px 0 0 0;
			background: rgb(164, 164, 164);
			color: rgba(0, 0, 0, 0.71);
		}

	}
</style>
